// extracted by mini-css-extract-plugin
export var legendIndicator = "_ew-1";
export var legendRight = "_ew-0";